import equal from "fast-deep-equal";

export default ( a: Record<string, any>, b: Record<string, any> ): boolean => equal( a, b );
